import { IonAccordion } from "@ionic/react";
import { AllieAccordionProps } from "./Accordion.types";

export const AllieAccordion: React.FC<AllieAccordionProps> = (props) => (
  <IonAccordion {...props} />
);
